import React, { useState } from 'react'

import { CardWrapper } from '../CardWrapper'
import { InfoGroup } from '../InfoGroup'
import { EditAddressModal } from './EditAddressModal'
import { useEditAddressForm } from './useEditAddressForm'

import * as S from './styles'

export const AddressSettings = (): JSX.Element => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const { userData, hasAddressData, formMethods } = useEditAddressForm()

  if (!hasAddressData) return null

  const addressData = userData.address_data
  const addressInfo = [
    { label: 'CEP', value: addressData['cep'] },
    { label: 'Endereço', value: addressData['address'] },
    { label: 'Número', value: addressData['address_number'] },
    { label: 'Complemento', value: addressData['complement'] },
    { label: 'Bairro', value: addressData['neighborhood'] },
    { label: 'Cidade', value: addressData['city'] },
    { label: 'Estado', value: addressData['state'] }
  ]

  return (
    <>
      <S.Container>
        <CardWrapper
          title='Meu endereço'
          subtitle='Para o envio de receitas médicas de Psiquiatria.'
        >
          <InfoGroup 
            info={addressInfo} 
            actionText='Modificar endereço'
            actionClick={() => setIsModalOpen(true)} 
          />
        </CardWrapper>
      </S.Container>
      {isModalOpen && (
        <EditAddressModal 
          closeModal={() => setIsModalOpen(false)} 
          formMethods={formMethods}
        />
      )}
    </>
  )
}